import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout"; // Path apne hisaab se adjust karein
import PageTitle from "../components/ui/PageTitle"; // Path apne hisaab se adjust karein
import { Save, ArrowLeft, Image as ImageIcon, Video as VideoIcon, Link as LinkIcon } from "lucide-react";
import api from "../../services/api"; // Path apne hisaab se adjust karein
import toast from "react-hot-toast";

export default function AddVideo() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [uploadType, setUploadType] = useState("url"); // 'url' ya 'file'

  const [formData, setFormData] = useState({
    title: "",
    video_url: "",
    status: "active",
  });
  
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!thumbnailFile) return toast.error("Please upload a thumbnail image.");
    if (uploadType === "url" && !formData.video_url) return toast.error("Please enter a YouTube/Video URL.");
    if (uploadType === "file" && !videoFile) return toast.error("Please upload a video file.");

    setLoading(true);

    try {
      const token = localStorage.getItem("admin_token");
      
      // Kyunki files bhej rahe hain, humein FormData use karna padega
      const data = new FormData();
      data.append("title", formData.title);
      data.append("status", formData.status);
      data.append("thumbnail", thumbnailFile);
      
      if (uploadType === "url") {
          data.append("video_url", formData.video_url);
      } else {
          data.append("video_file", videoFile);
      }

      await api.post("/videos", data, {
        headers: { 
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
        },
      });

      toast.success("Video added successfully!");
      navigate("/videos"); // Redirect to list page

    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to add video.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <button 
            onClick={() => navigate(-1)} 
            className="flex items-center gap-2 text-sm text-gray-500 hover:text-black mb-2 transition-colors cursor-pointer"
          >
            <ArrowLeft size={16} /> Back to Videos
          </button>
          <PageTitle title="Add New Video" subtitle="Upload a new video or embed a YouTube link." />
        </div>
        
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-2 px-6 rounded-lg transition-colors disabled:opacity-50 cursor-pointer"
        >
          <Save size={18} />
          {loading ? "Saving..." : "Publish Video"}
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow border border-gray-200 p-8 max-w-3xl">
        <form onSubmit={handleSubmit} className="space-y-6">
          
          {/* Title */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Video Title *</label>
            <input type="text" name="title" required value={formData.title} onChange={handleChange} placeholder="e.g. Kadtech HR Platform Tour" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" />
          </div>

          {/* Thumbnail Upload */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2"><ImageIcon size={16}/> Thumbnail Image * (Max 5MB)</label>
            <input type="file" accept="image/*" onChange={(e) => setThumbnailFile(e.target.files[0])} className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500 bg-gray-50" required />
          </div>

          {/* Upload Type Selection */}
          <div className="pt-4 border-t border-gray-100">
            <label className="block text-sm font-medium text-gray-700 mb-3">How do you want to add the video?</label>
            <div className="flex gap-4 mb-4">
                <label className="flex items-center gap-2 cursor-pointer">
                    <input type="radio" name="uploadType" value="url" checked={uploadType === "url"} onChange={() => setUploadType("url")} className="accent-yellow-500 w-4 h-4" />
                    <span className="text-sm font-semibold text-gray-700 flex items-center gap-1"><LinkIcon size={16}/> YouTube / External Link</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                    <input type="radio" name="uploadType" value="file" checked={uploadType === "file"} onChange={() => setUploadType("file")} className="accent-yellow-500 w-4 h-4" />
                    <span className="text-sm font-semibold text-gray-700 flex items-center gap-1"><VideoIcon size={16}/> Direct MP4 Upload</span>
                </label>
            </div>

            {uploadType === "url" ? (
                <div>
                    <input type="url" name="video_url" value={formData.video_url} onChange={handleChange} placeholder="e.g. https://www.youtube.com/watch?v=..." className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500" />
                </div>
            ) : (
                <div>
                    <input type="file" accept="video/mp4,video/quicktime" onChange={(e) => setVideoFile(e.target.files[0])} className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500 bg-gray-50" />
                    <p className="text-xs text-gray-500 mt-1">Accepted formats: MP4, MOV (Max 50MB)</p>
                </div>
            )}
          </div>

          {/* Status */}
          <div className="pt-4 border-t border-gray-100 w-full md:w-1/2">
            <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
            <select name="status" value={formData.status} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-4 py-2.5 outline-none focus:ring-2 focus:ring-yellow-500 bg-white">
              <option value="active">Active (Visible on Frontend)</option>
              <option value="inactive">Inactive (Hidden)</option>
            </select>
          </div>
          
        </form>
      </div>
    </AdminLayout>
  );
}